<template>
<div class="container-download">
	<v-btn
		slot="activator"
		color="primary"
		dark
		:loading="isLoading"
		@click="getFile"
	>
		<v-icon>cloud_download</v-icon> &nbsp;
		{{ textButton }}
	</v-btn>
	<a ref="linkFile"
		download="report.xlsx"
		:href="hrefFile"
		class="link-file-hide"
	>
		Download File
	</a>
</div>
</template>

<script>
export default {
	data: () => ({
		hrefFile: null
	}),
	props: {
		isLoading: {
			type: Boolean,
			default: false
		},
		file: {
			type: ArrayBuffer,
			default: []
		},
		textButton: {
			type: String,
			default: ''
		}
	},
	methods: {
		getFile() {
			this.$emit('load')
		},
		clearFile() {
			this.$emit('onClear', new ArrayBuffer())
		}
	},
	watch: {
		file() {
			if (this.file.byteLength === 0) return
			const blob = new Blob([new Uint8Array(this.file)], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			})
			this.hrefFile = window.URL.createObjectURL(blob)
			this.$refs.linkFile.click()
			this.clearFile()
		}
	},
	updated: function() {
		if (this.hrefFile) {
			this.$refs.linkFile.click()
			this.hrefFile = null
		}
	}
}
</script>

<style scoped>
.link-file-hide {
	visibility: hidden;
}
.container-download {
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
}
</style>
